import { CharacterTranslationStatus } from "./constants";
// eslint-disable-next-line id-length -- matches useTranslation().t; literal t("chat:…") keys for grep / i18n extractors
export default function getCharacterTranslationStatusMessage(t) {
    return {
        [CharacterTranslationStatus.PREPARE_TRANSLATION]: t("chatbot:modal.translation.status.prepareTranslation"),
        [CharacterTranslationStatus.ANALYZE_CONTENT]: t("chatbot:modal.translation.status.analyzeContent"),
        [CharacterTranslationStatus.TRANSLATE_TITLE]: t("chatbot:modal.translation.status.translateTitle"),
        [CharacterTranslationStatus.TRANSLATE_PERSONA]: t("chatbot:modal.translation.status.translatePersona"),
        [CharacterTranslationStatus.TRANSLATE_GREETING]: t("chatbot:modal.translation.status.translateGreeting"),
        [CharacterTranslationStatus.FINALIZE_TRANSLATION]: t("chatbot:modal.translation.status.finalizeTranslation"),
        [CharacterTranslationStatus.WAITING_FOR_CONFIRMATION]: t("chatbot:modal.translation.status.waitingForConfirmation"),
        [CharacterTranslationStatus.COMPLETED]: t("chatbot:modal.translation.status.completed"),
    };
}
